import { useState } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import { countryDefinitions, countryName } from 'common/helpers/addresses';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';

const ZipCode = (props) => {
  const { hasZipCode, settings } = props;
  const [isShowZipCode, setIsShowZipCode] = useState(true);

  if (!hasZipCode) {
    return null;
  }

  const handleHideZipCode = (e) => {
    e.preventDefault();
    setIsShowZipCode(false);
  };

  const handleShowZipCode = (e) => {
    e.preventDefault();
    setIsShowZipCode(true);
  };

  if (!settings.data) {
    return null;
  }

  const countryCode = getDefaultCountryCode(settings);
  const country = countryName(countryCode);

  if (!isShowZipCode) {
    return (
      <>
        <a href="" onClick={handleShowZipCode}>
          From {country}
        </a>
      </>
    );
  }

  const zipCodeSchema = countryDefinitions[countryCode].schema.zipCode;

  return (
    <>
      <Field
        name="zipCode"
        component={TextField}
        label={zipCodeSchema.label}
        normalize={zipCodeSchema.normalize}
        required
        autocomplete="postal-code"
      />
      <a href="" onClick={handleHideZipCode}>
        Not from {country}
      </a>
    </>
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(ZipCode);
